module.exports = __webpack_public_path__ + "19f8dad54b1a69026b4656eb34509c98.png";